import {NgModule} from '@angular/core';
import {ManagementComponent} from './management.component';
import {SharedProviderModule} from '../shared/shared.module';
import {VivoModule} from '../vivo/vivo.module';
import {LinkingModule} from '../linking/linking.module';
import {NgbAccordionModule, NgbNavModule} from '@ng-bootstrap/ng-bootstrap';
import {FormDataModule} from '../form-data/form-data.module';

@NgModule({
  imports: [
    FormDataModule,
    LinkingModule,
    SharedProviderModule,
    NgbNavModule,
    NgbAccordionModule,
    VivoModule
  ],
  declarations: [ManagementComponent],
  exports: [ManagementComponent]
})
export class ManagementModule {
}
